var TaskTableHeaderLabels = {
  cpus: "CPU",
  disk: "DISK",
  host: "HOST",
  mem: "MEM",
  id: "ID",
  name: "NAME",
  status: "STATUS",
  health: "HEALTH",
  updated: "UPDATED",
  version: "VERSION"
};

module.exports = TaskTableHeaderLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/TaskTableHeaderLabels.js